import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class VideoProductionAndAdvertising extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Video Production and Advertising"
					title={"video production and advertising"}
					image={require('./image-11.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Video Production
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
							
<h3>If a photo speaks a thousand words, what impact would video have? </h3>

								<p>High quality video is crucial for your audience having an enjoyable viewing experience. At Moshi Moshi Marketing, we can provide still image, 4k footage and animated videos depending on what your budget and needs are, with optional features such as voice over. </p>

								<br></br><h4>Moshi can help you create professionally shot and edited short videos to promote your business or educate your market, at a price you can afford.</h4>
								
       
<p>With access to drone, 360°, and virtual reality video, we can help you create whatever kind of video you require for your business, whether you need it for advertising or customer education. If you need something for TV, Moshi can manage the advertising classification and CAD approval as well. You may have even seen some of our television ads for Bunbury Turf Club!
</p> 
<p>Examples of our video work can be found on our <a href="https://www.youtube.com/channel/UCu7qr0r5KUV5TdPq42XDy9Q">YouTube channel</a> . </p>
<a href="https://www.youtube.com/watch?v=24-msuQiahs"><img src={require('./telethon.png')} style={{padding: 30}}  height="375" width="350" alt="Behind the Scenes of Telethon's Photoshoot" className="align-centre" align="centre" /></a>
<a href="https://www.youtube.com/watch?v=64wvYvoXeZg"><img src={require('./Prince.png')} style={{padding: 30}} height="375" width="350" alt="The Prince of Wales Video Footage" className="align-centre" align="centre" /></a>

<a href="https://www.youtube.com/watch?v=HfWWkpsmer8"><img src={require('./BTC.png')} style={{padding: 30}} height="375" width="350" alt="Bunbury Turf Club Video Footage" className="align-centre" align="centre" /></a>

<br></br>
<hr></hr>
<h2>Related Services</h2>
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-marketing">Social Media Marketing</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-and-newsletter-content-writing">Website and Newsletter Content Writing</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-advertising">Google Advertising</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/brand-and-logo-design">Brand and Logo Design</a>	

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>

<hr></hr>
<br></br>
<h4>Are you looking to add video content into your website, social pages or Google advertising?</h4>
<h3> Get in touch with the team at Moshi Moshi Marketing for a zero obligation meeting. </h3>

<iframe width="560" height="315" src="https://www.youtube.com/embed/NGkoHS_yLDU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
				</div>

			</div>
		);
	}
}

export default VideoProductionAndAdvertising;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/VideoProductionAndAdvertising.js